import LicenseDetailTabs from './LicenseDetailTabs.container';
export default LicenseDetailTabs;
